import React from 'react'
import styled from 'styled-components'

const SVG = styled.svg`
  .st0 {
    fill: #a5dacf;
  }
  .st1 {
    fill: #537f6e;
    transition: fill 0.2s ease;
  }
  .st2 {
    fill: #83a195;
  }
  .st3 {
    fill: #b9c9c2;
  }
  .st4 {
    fill: rgba(134, 207, 194, 0.1);
  }
  .st5 {
    fill: #004a33;
    transition: fill 0.2s ease;
  }
  .st6 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #004a33;
    transition: fill 0.2s ease;
  }
  .st7 {
    fill: #fdfdfd;
  }
  .st8 {
    font-family: 'BonavaSans-Italic';
  }
  .st9 {
    font-size: 5.812px;
  }
  .st10 {
    fill: none;
  }
  .st11 {
    fill: #65c5b4;
    transition: fill 0.2s ease;
  }
  .st12 {
    fill: url(#B60cone_1_);
  }
  .st13 {
    fill: #ffffff;
  }
  .st14 {
    fill: url(#B61cone_1_);
  }
  .st15 {
    fill: url(#B62cone_1_);
  }
  .st16 {
    fill: url(#B63cone_1_);
  }
  .st17 {
    fill: #86cfc2;
  }

  #B63,
  #B62,
  #B61,
  #B60,
  #B63_1_,
  #B62_1_,
  #B61_1_,
  #B60a {
    cursor: pointer;
    transition: fill 0.2s ease;

    &:hover {
      fill: #83a195;
    }
  }

  .active-apt {
    fill: #a5dacf;
  }

  .on-hover {
    fill: #83a195;
  }

  .reserved {
    fill: yellow;
  }

  .sold {
    fill: red;
  }

  #up_2_,
  #down_2_ {
    cursor: pointer;
    transition: fill 0.2s ease;

    &:hover .st8 {
      fill: #83a195;
    }
    &:hover .st5 {
      fill: #ffffff;
    }
  }

  .switch {
    cursor: pointer;
  }
`

export default function Floor6({
  activeApartment,
  changeFloor,
  changeView,
  hLookAt,
  toggleSceneName2020,
  isSceneName2020,
}) {
  const [elementOnHover, setElementOnHover] = React.useState('')
  const { sceneName, apartmentNumber } = activeApartment

  return (
    <SVG
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 250.9 136.4"
      xmlSpace="preserve"
      enableBackground="new 0 0 250.9 136.4"
    >
      <g id="siteplan_2_"></g>
      <g id="levelsection_2_"></g>
      <g id="levelfloor_2_">
        <g id="static_2_">
          <path
            id="plate_6_"
            className="st4"
            d="M248.5,136.4H2.4c-1.3,0-2.4-1.1-2.4-2.4V2.4C0,1.1,1.1,0,2.4,0h246.1c1.3,0,2.4,1.1,2.4,2.4
			V134C250.9,135.3,249.9,136.4,248.5,136.4z"
          />
          <path
            id="bonava_6_"
            className="st5"
            d="M207.5,121.4c0.6-0.2,0.9-0.7,0.9-1.4c0-0.9-0.8-1.6-1.9-1.6h-2.8v6h2.8c1.2,0,2-0.6,2-1.7
			C208.6,122.1,208.2,121.6,207.5,121.4z M204.8,119.3h1.7c0.6,0,1,0.3,1,0.8c0,0.5-0.4,0.8-1,0.8h-1.7V119.3z M206.6,123.5h-1.8
			v-1.7l1.8,0c0.6,0,1,0.3,1,0.8C207.6,123.3,207.2,123.5,206.6,123.5z M213.3,118.3c-1.8,0-2.9,1.4-2.9,3.1c0,1.7,1.1,3.1,2.9,3.1
			c1.8,0,2.9-1.4,2.9-3.1C216.1,119.7,215.1,118.3,213.3,118.3z M213.3,123.6c-1.2,0-1.9-1-1.9-2.2c0-1.2,0.7-2.2,1.9-2.2
			c1.2,0,1.9,1,1.9,2.2C215.1,122.6,214.5,123.6,213.3,123.6z M222.1,122.8l-2.9-4.3h-1.1v6h1v-4.5l3.1,4.5h0.9v-6h-1V122.8z
			 M227.2,118.4l-2.4,6h1l0.5-1.3h2.6l0.5,1.3h1.1l-2.4-6H227.2z M226.7,122.2l1-2.5l1,2.5H226.7z M234,123l-1.7-4.6h-1.1l2.3,6h0.9
			l2.2-6h-1L234,123z M240.7,118.4h-0.9l-2.4,6h1l0.5-1.3h2.6l0.5,1.3h1.1L240.7,118.4z M239.3,122.2l1-2.5l1,2.5H239.3z
			 M227.2,113.2c0-0.8-0.3-1.6-0.9-2.1l-0.4-0.4l0.1-0.1l0,0c0.4-0.4,0.6-0.9,0.6-1.4c0-1.1-0.9-2-2-2l-2,0v1.8h1v-0.9h1
			c0.6,0,1.1,0.5,1.1,1.1c0,0.3-0.1,0.5-0.3,0.7l-3.2,3.2v-2.4h-1v2.5c0,0.3,0,0.5,0.1,0.8l-1.5,1.5l0.7,0.7l1.3-1.3
			c0.5,0.8,1.5,1.3,2.5,1.3C225.8,116.1,227.2,114.8,227.2,113.2z M224.2,115.2c-0.7,0-1.4-0.4-1.8-1l2.8-2.8l0.4,0.4l0,0
			c0.4,0.4,0.6,0.9,0.6,1.5C226.2,114.3,225.3,115.2,224.2,115.2z"
          />
          <polygon
            id="floor_3_"
            className="st5"
            points="190.4,10.6 7.4,10.6 22,35 78.7,129.4 125.3,101.5 190.5,101.5 		"
          />
          <path
            id="B60"
            onClick={() => changeView(8, 60)}
            className={`st1 ${
              sceneName === 'scene_B60a_08_krs'
                ? 'active-apt'
                : elementOnHover === 'B60a'
                ? 'on-hover'
                : ''
            }`}
            d="M189.9,88.9l-42-0.1V101h42.2L189.9,88.9z M166.7,13.8h-29.3v31.9h29.3V13.8z M137.4,47.2v8.6
			l13.6,0l0.1,30.2h36.2V13.8h-19.1v33.4L137.4,47.2z"
          />
          <path
            id="B61"
            onClick={() => changeView(8, 61)}
            className={`st1 ${
              sceneName === 'scene_B61_08_krs'
                ? 'active-apt'
                : elementOnHover === 'B61'
                ? 'on-hover'
                : ''
            }`}
            d="M118.9,57.4v11.9l-11.1,0v4.2l-11.4,0v11.3l6.1,10.3l15.2-9.1h31.6V57.4H118.9z M118.5,88.9
			l-14.8,8.9l7.1,11.8l14.4-8.5h22.1l0-12.1L118.5,88.9z"
          />
          <path
            id="B62"
            onClick={() => changeView(8, 62)}
            className={`st1 ${
              sceneName === 'scene_B62_08_krs'
                ? 'active-apt'
                : elementOnHover === 'B62'
                ? 'on-hover'
                : ''
            }`}
            d="M101.3,95.8l-6.5-10.6l0.1-27.8h-9.1L51.5,78l21,35L101.3,95.8z M103.1,98.1l-31.3,18.8l7.1,11.8
			l31.4-18.8L103.1,98.1z"
          />
          <path
            id="B63"
            onClick={() => changeView(8, 63)}
            className={`st1 ${
              sceneName === 'scene_B63_08_krs'
                ? 'active-apt'
                : elementOnHover === 'B63'
                ? 'on-hover'
                : ''
            }`}
            d="M74.8,46.9V13.8H25.3v20.7l25.3,42.3l34.7-20.9v-9L74.8,46.9z M22.3,34.5l0.1-23.4H8.3L22.3,34.5z"
          />
          <rect
            id="B64"
            x="76.2"
            y="13.8"
            className="st1"
            width="28.5"
            height="31.6"
          />
          <polygon
            id="hall_3_"
            className="st5"
            points="136.1,13.8 127.1,13.8 127.1,44 113.6,44 113.6,46.8 86.8,46.8 86.8,55.8 136.1,55.8
			"
          />
          <polygon
            id="stairs_3_"
            className="st5"
            points="106.1,45.5 112.4,45.5 112.4,42.9 125.8,42.9 126,13.8 106.1,13.8 		"
          />
          <polygon
            id="lifts_3_"
            className="st5"
            points="117.4,57 96.4,57 96.4,72 106.3,72 106.3,67.8 117.4,67.8 		"
          />
          <g id="compass_3_">
            <polygon
              id="south_3_"
              className="st0"
              points="19,103.7 28.6,114.4 30.1,100 30.1,100 19.3,103.5 			"
            />
            <polygon
              id="north_3_"
              className="st6"
              points="20,88.1 18.5,102.4 19.4,102.1 29.7,98.7 20.1,88.1 			"
            />
            <path
              id="p_6_"
              className="st7"
              d="M24.1,94.5c0.2,0.8-0.1,1.7-1.1,2l-1.3,0.4l0.2,1.6l-0.5,0.2l-0.5-4.4l1.7-0.5
				C23.1,93.6,23.8,93.8,24.1,94.5z M23.6,94.7c-0.1-0.5-0.5-0.6-1-0.5l-1.2,0.4l0.2,1.8l1.2-0.4C23.5,95.8,23.7,95.3,23.6,94.7z"
            />
            <path
              id="e_6_"
              className="st7"
              d="M24.1,103.4l2.8-0.9l0.1,0.5l-2.3,0.7l0.2,1.4l2.1-0.7L27,105l-2.1,0.7l0.2,1.4l2.3-0.7l0.1,0.5
				l-2.8,0.9L24.1,103.4z"
            />
          </g>
        </g>
        <g id="apartmentnr_2_">
          <g
            id="B60a"
            onClick={() => changeView(8, 60)}
            onMouseOver={() => setElementOnHover('B60a')}
            onMouseLeave={() => setElementOnHover('')}
          >
            <g id="B60a_1_">
              <circle className="st5" cx="169" cy="65.9" r="9.1" />
            </g>
            <g>
              <path
                className="st10"
                d="M163.1,66.2h-1.2v1.1h1.2c0.4,0,0.6-0.2,0.6-0.5C163.8,66.4,163.5,66.2,163.1,66.2z"
              />
              <path
                className="st10"
                d="M175,67.2c0,0.2,0.1,0.3,0.4,0.3c0.4,0,0.7-0.3,0.7-0.6v-0.3c-0.1,0.1-0.3,0.1-0.5,0.1
					C175.2,66.9,175,66.9,175,67.2z"
              />
              <g>
                <path
                  className="st0"
                  d="M164.7,66.8c0,0.8-0.7,1.2-1.5,1.2h-2.1v-4.4h2.1c0.9,0,1.4,0.4,1.4,1.1c0,0.5-0.3,0.8-0.7,1v0
						C164.4,66,164.7,66.3,164.7,66.8z M161.9,64.5v1h1.1c0.4,0,0.6-0.2,0.6-0.5c0-0.4-0.3-0.5-0.6-0.5H161.9z M163.8,66.8
						c0-0.4-0.3-0.5-0.6-0.5h-1.2v1.1h1.2C163.5,67.3,163.8,67.1,163.8,66.8z"
                />
                <path
                  className="st0"
                  d="M168.4,64.3c-0.6,0-0.8,0.5-0.9,1.3h0c0.2-0.2,0.6-0.4,1-0.4c0.9,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.5-1.6,1.5
						c-1.3,0-1.7-1-1.7-2.2c0-1.3,0.4-2.4,1.8-2.4c0.9,0,1.4,0.5,1.5,1.2l-0.8,0C169,64.5,168.8,64.3,168.4,64.3z M169.2,66.7
						c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.2,0.8,0.8,0.8C168.9,67.4,169.2,67.1,169.2,66.7z"
                />
                <path
                  className="st0"
                  d="M170.4,65.9c0-1.2,0.3-2.3,1.7-2.3c1.3,0,1.7,1.1,1.7,2.3c0,1.2-0.3,2.3-1.7,2.3
						C170.8,68.2,170.4,67.1,170.4,65.9z M172.9,65.9c0-0.7-0.1-1.5-0.8-1.5c-0.7,0-0.8,0.8-0.8,1.5s0.1,1.5,0.8,1.5
						C172.8,67.4,172.9,66.6,172.9,65.9z"
                />
                <path
                  className="st0"
                  d="M176.1,67.8L176.1,67.8c-0.2,0.2-0.5,0.4-0.9,0.4c-0.6,0-1-0.4-1-0.9c0-0.3,0.1-0.5,0.3-0.7
						c0.2-0.2,0.6-0.2,1-0.3c0.5-0.1,0.6-0.1,0.6-0.3c0-0.2-0.2-0.3-0.5-0.3c-0.4,0-0.5,0.1-0.5,0.4h-0.8c0.1-0.7,0.6-1.1,1.4-1.1
						c0.9,0,1.3,0.4,1.3,1.1v2.1h-0.8V67.8z M175.6,66.8c-0.4,0.1-0.6,0.1-0.6,0.3c0,0.2,0.1,0.3,0.4,0.3c0.4,0,0.7-0.3,0.7-0.6
						v-0.3C176,66.7,175.9,66.7,175.6,66.8z"
                />
              </g>
            </g>
          </g>
          <g id="B60b">
            <g id="B60b_1_">
              <circle className="st5" cx="152.8" cy="29.6" r="9.1" />
            </g>
            <g>
              <path
                className="st10"
                d="M147.3,28.6c0-0.4-0.3-0.5-0.6-0.5h-1.1v1h1.1C147,29.1,147.3,28.9,147.3,28.6z"
              />
              <path
                className="st10"
                d="M146.7,29.9h-1.2v1.1h1.2c0.4,0,0.6-0.2,0.6-0.5C147.4,30,147.1,29.9,146.7,29.9z"
              />
              <path
                className="st10"
                d="M159.5,29.2c-0.5,0-0.7,0.4-0.7,0.9c0,0.5,0.3,0.9,0.7,0.9c0.5,0,0.7-0.4,0.7-0.9
					C160.2,29.6,160,29.2,159.5,29.2z"
              />
              <g>
                <path
                  className="st0"
                  d="M148.2,30.5c0,0.8-0.7,1.2-1.5,1.2h-2.1v-4.4h2.1c0.9,0,1.4,0.4,1.4,1.1c0,0.5-0.3,0.8-0.7,1v0
						C147.9,29.6,148.2,29.9,148.2,30.5z M145.5,28.1v1h1.1c0.4,0,0.6-0.2,0.6-0.5c0-0.4-0.3-0.5-0.6-0.5H145.5z M147.4,30.4
						c0-0.4-0.3-0.5-0.6-0.5h-1.2v1.1h1.2C147.1,30.9,147.4,30.7,147.4,30.4z"
                />
                <path
                  className="st0"
                  d="M152,28c-0.6,0-0.8,0.5-0.9,1.3h0c0.2-0.2,0.6-0.4,1-0.4c0.9,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.5-1.6,1.5
						c-1.3,0-1.7-1-1.7-2.2c0-1.3,0.4-2.4,1.8-2.4c0.9,0,1.4,0.5,1.5,1.2l-0.8,0C152.6,28.1,152.4,28,152,28z M152.7,30.3
						c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.2,0.8,0.8,0.8C152.5,31,152.7,30.7,152.7,30.3z"
                />
                <path
                  className="st0"
                  d="M154,29.5c0-1.2,0.3-2.3,1.7-2.3c1.3,0,1.7,1.1,1.7,2.3c0,1.2-0.3,2.3-1.7,2.3
						C154.3,31.8,154,30.7,154,29.5z M156.5,29.5c0-0.7-0.1-1.5-0.8-1.5c-0.7,0-0.8,0.8-0.8,1.5s0.1,1.5,0.8,1.5
						C156.4,31,156.5,30.2,156.5,29.5z"
                />
                <path
                  className="st0"
                  d="M157.9,27.3h0.8v1.6h0c0.2-0.2,0.5-0.4,0.9-0.4c0.8,0,1.4,0.7,1.4,1.6c0,0.9-0.5,1.7-1.4,1.7
						c-0.4,0-0.7-0.1-0.9-0.4h0v0.3h-0.8V27.3z M160.2,30.1c0-0.5-0.2-0.9-0.7-0.9c-0.5,0-0.7,0.4-0.7,0.9c0,0.5,0.2,0.9,0.7,0.9
						C159.9,31.1,160.2,30.7,160.2,30.1z"
                />
              </g>
            </g>
          </g>
          <g
            id="B61_1_"
            onClick={() => changeView(8, 61)}
            onMouseOver={() => setElementOnHover('B61')}
            onMouseLeave={() => setElementOnHover('')}
          >
            <g id="B61_3_">
              <circle className="st5" cx="134.5" cy="71.7" r="9.1" />
            </g>
            <g>
              <path
                className="st10"
                d="M129.5,72.1h-1.4v1.2h1.4c0.4,0,0.8-0.2,0.8-0.6S130,72.1,129.5,72.1z"
              />
              <path
                className="st10"
                d="M140.1,71.7c-0.5,0-0.9,0.3-0.9,0.8c0,0.4,0.3,0.9,0.9,0.9c0.6,0,0.9-0.4,0.9-0.9
					C140.9,72.1,140.6,71.7,140.1,71.7z"
              />
              <g>
                <path
                  className="st0"
                  d="M131.3,72.8c0,0.9-0.8,1.5-1.8,1.5h-2.4v-5.2h2.5c1,0,1.6,0.5,1.6,1.3c0,0.5-0.3,1-0.8,1.2v0
						C131,71.8,131.3,72.2,131.3,72.8z M128.1,70v1.2h1.3c0.4,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6H128.1z M130.3,72.7
						c0-0.4-0.3-0.6-0.8-0.6h-1.4v1.2h1.4C129.9,73.3,130.3,73.1,130.3,72.7z"
                />
                <path
                  className="st0"
                  d="M135.7,69.9c-0.7,0-1,0.6-1,1.5h0c0.3-0.3,0.7-0.4,1.2-0.4c1,0,1.7,0.7,1.7,1.7c0,1-0.7,1.8-1.9,1.8
						c-1.6,0-2-1.2-2-2.5c0-1.5,0.5-2.8,2.1-2.8c1,0,1.6,0.6,1.7,1.4l-1,0C136.4,70.1,136.1,69.9,135.7,69.9z M136.6,72.6
						c0-0.5-0.3-0.9-0.9-0.9c-0.5,0-0.9,0.3-0.9,0.8c0,0.4,0.2,0.9,0.9,0.9C136.2,73.5,136.6,73.1,136.6,72.6z"
                />
                <path
                  className="st0"
                  d="M139.6,73.3v-3.2c-0.4,0.3-0.8,0.4-1.2,0.6v-1c0.5-0.2,1-0.4,1.4-0.7h0.8v4.3h1.2v0.9h-3.4v-0.9H139.6z"
                />
              </g>
            </g>
          </g>
          <g
            id="B62_1_"
            onClick={() => changeView(8, 62)}
            onMouseOver={() => setElementOnHover('B62')}
            onMouseLeave={() => setElementOnHover('')}
          >
            <g id="B62_3_">
              <circle className="st5" cx="77.8" cy="86" r="9.1" />
            </g>
            <g>
              <path
                className="st10"
                d="M73.5,84.9c0-0.4-0.3-0.6-0.7-0.6h-1.3v1.2h1.3C73.1,85.5,73.5,85.3,73.5,84.9z"
              />
              <g>
                <path
                  className="st0"
                  d="M74.6,87.1c0,0.9-0.8,1.5-1.8,1.5h-2.4v-5.2h2.5c1,0,1.6,0.5,1.6,1.3c0,0.5-0.3,1-0.8,1.2v0
						C74.3,86,74.6,86.4,74.6,87.1z M71.4,84.3v1.2h1.3c0.4,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6H71.4z M73.6,87
						c0-0.4-0.3-0.6-0.8-0.6h-1.4v1.2h1.4C73.2,87.6,73.6,87.4,73.6,87z"
                />
                <path
                  className="st0"
                  d="M79,84.1c-0.7,0-1,0.6-1,1.5h0c0.3-0.3,0.7-0.4,1.2-0.4c1,0,1.7,0.7,1.7,1.7c0,1-0.7,1.8-1.9,1.8
						c-1.6,0-2-1.2-2-2.5c0-1.5,0.5-2.8,2.1-2.8c1,0,1.6,0.6,1.7,1.5l-1,0C79.7,84.3,79.4,84.1,79,84.1z M79.9,86.8
						c0-0.5-0.3-0.9-0.9-0.9c-0.5,0-0.9,0.3-0.9,0.8c0,0.4,0.2,0.9,0.9,0.9C79.5,87.7,79.9,87.3,79.9,86.8z"
                />
                <path
                  className="st0"
                  d="M85.1,87.6v0.9h-3.6v-0.8l1.8-1.7c0.4-0.4,0.7-0.7,0.7-1.1c0-0.4-0.3-0.7-0.8-0.7c-0.5,0-0.8,0.3-0.8,0.8
						h-1c0.1-0.9,0.7-1.6,1.8-1.6c1.2,0,1.8,0.7,1.8,1.6c0,0.6-0.3,1.1-0.9,1.7l-1.2,1.1H85.1z"
                />
              </g>
            </g>
          </g>
          <g
            id="B63_1_"
            onClick={() => changeView(8, 63)}
            onMouseOver={() => setElementOnHover('B63')}
            onMouseLeave={() => setElementOnHover('')}
          >
            <g id="B63_3_">
              <circle className="st5" cx="51.5" cy="32.1" r="9.1" />
            </g>
            <g>
              <path
                className="st10"
                d="M46.5,32.5h-1.4v1.2h1.4c0.4,0,0.8-0.2,0.8-0.6S46.9,32.5,46.5,32.5z"
              />
              <g>
                <path
                  className="st0"
                  d="M48.3,33.3c0,0.9-0.8,1.4-1.8,1.4H44v-5.2h2.5c1,0,1.6,0.5,1.6,1.3c0,0.5-0.3,1-0.8,1.2v0
						C47.9,32.2,48.3,32.6,48.3,33.3z M45.1,30.5v1.2h1.3c0.4,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6H45.1z M47.2,33.2
						c0-0.4-0.3-0.6-0.8-0.6h-1.4v1.2h1.4C46.9,33.8,47.2,33.6,47.2,33.2z"
                />
                <path
                  className="st0"
                  d="M52.6,30.3c-0.7,0-1,0.6-1,1.5h0c0.3-0.3,0.7-0.4,1.2-0.4c1,0,1.7,0.7,1.7,1.7c0,1-0.7,1.8-1.9,1.8
						c-1.6,0-2-1.2-2-2.5c0-1.5,0.5-2.8,2.1-2.8c1,0,1.6,0.6,1.7,1.4l-1,0C53.3,30.5,53.1,30.3,52.6,30.3z M53.5,33
						c0-0.5-0.3-0.9-0.9-0.9c-0.5,0-0.9,0.3-0.9,0.8c0,0.4,0.2,0.9,0.9,0.9C53.2,33.9,53.5,33.5,53.5,33z"
                />
                <path
                  className="st0"
                  d="M56.9,31.7c0.5,0,0.8-0.3,0.8-0.7c0-0.4-0.3-0.7-0.8-0.7c-0.5,0-0.8,0.3-0.8,0.6h-1c0-0.8,0.6-1.5,1.8-1.5
						c1.2,0,1.8,0.6,1.8,1.5c0,0.5-0.2,0.9-0.6,1.1v0c0.5,0.3,0.7,0.7,0.7,1.2c0,0.9-0.7,1.5-1.9,1.5c-1.2,0-1.9-0.7-1.9-1.5h1
						c0,0.4,0.4,0.7,0.9,0.7c0.6,0,0.9-0.3,0.9-0.7c0-0.4-0.3-0.7-0.9-0.7h-0.7v-0.8H56.9z"
                />
              </g>
            </g>
          </g>
          <g id="B64_1_">
            <g id="B64_2_">
              <circle className="st5" cx="90.5" cy="29.4" r="9.1" />
            </g>
            <g>
              <path
                className="st10"
                d="M86.1,28.4c0-0.4-0.3-0.6-0.7-0.6h-1.3V29h1.3C85.8,29,86.1,28.8,86.1,28.4z"
              />
              <path
                className="st10"
                d="M85.5,29.8h-1.4v1.2h1.4c0.4,0,0.8-0.2,0.8-0.6S85.9,29.8,85.5,29.8z"
              />
              <path
                className="st10"
                d="M95.9,27.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.3,0.9,0.8,0.9c0.5,0,0.9-0.3,0.9-0.8
					C96.7,28.1,96.5,27.6,95.9,27.6z"
              />
              <path
                className="st0"
                d="M86.4,29.3L86.4,29.3c0.5-0.2,0.8-0.6,0.8-1.2c0-0.8-0.6-1.3-1.6-1.3h-2.5V32h2.4c1,0,1.8-0.5,1.8-1.5
					C87.3,29.9,86.9,29.5,86.4,29.3z M84.1,27.8h1.3c0.4,0,0.7,0.2,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6h-1.3L84.1,27.8L84.1,27.8z
					 M85.5,31.1h-1.4v-1.2h1.4c0.4,0,0.8,0.2,0.8,0.6S85.9,31.1,85.5,31.1z"
              />
              <g>
                <path
                  className="st0"
                  d="M87.3,30.5c0,0.9-0.8,1.4-1.8,1.4h-2.4v-5.2h2.5c1,0,1.6,0.5,1.6,1.3c0,0.5-0.3,1-0.8,1.2v0
						C86.9,29.5,87.3,29.9,87.3,30.5z M84.1,27.7V29h1.3c0.4,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6H84.1z M86.2,30.4
						c0-0.4-0.3-0.6-0.8-0.6h-1.4v1.2h1.4C85.9,31.1,86.2,30.9,86.2,30.4z"
                />
                <path
                  className="st0"
                  d="M91.7,27.6c-0.7,0-1,0.6-1,1.5h0c0.3-0.3,0.7-0.4,1.2-0.4c1,0,1.7,0.7,1.7,1.7c0,1-0.7,1.8-1.9,1.8
						c-1.6,0-2-1.2-2-2.5c0-1.5,0.5-2.8,2.1-2.8c1,0,1.6,0.6,1.7,1.4l-1,0C92.4,27.8,92.1,27.6,91.7,27.6z M92.5,30.3
						c0-0.5-0.3-0.9-0.9-0.9c-0.5,0-0.9,0.3-0.9,0.8c0,0.4,0.2,0.9,0.9,0.9C92.2,31.2,92.5,30.8,92.5,30.3z"
                />
                <path
                  className="st0"
                  d="M98,30.1v0.8h-0.8V32h-1v-1.1h-2.3v-0.6l2.2-3.4h1v3.3H98z M96.2,28.1L96.2,28.1l-1.3,2h1.3V28.1z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="floorplan_2_"></g>
      {/* <g id="state_5_" className="switch" onClick={toggleSceneName2020}>
        <path
          id="plate_40_"
          className="st2"
          d="M179,114.4h-51.6c-3.4,0-6.2,2.8-6.2,6.2c0,3.4,2.8,6.2,6.2,6.2H179c3.4,0,6.2-2.8,6.2-6.2
		C185.1,117.1,182.4,114.4,179,114.4z"
        />
        {isSceneName2020 ? (
          <g id="_x32_020_12_">
            <path
              id="plate_39_"
              className="st5"
              d="M136.8,114.9h-9.2c-3.1,0-5.7,2.5-5.7,5.7c0,3.1,2.5,5.7,5.7,5.7h9.2c3.1,0,5.7-2.5,5.7-5.7
			C142.4,117.4,139.9,114.9,136.8,114.9z"
            />
            <path
              id="_x32_020_13_"
              className="st17"
              d="M127.3,120.9c0.5-0.5,0.8-1,0.8-1.5c0-0.8-0.6-1.4-1.6-1.4c-1,0-1.5,0.6-1.6,1.4h0.9
			c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.6c0,0.3-0.2,0.6-0.6,1l-1.6,1.5v0.7h3.1v-0.8h-1.9L127.3,120.9z M130.4,118
			c-1.3,0-1.7,1.1-1.7,2.3c0,1.2,0.3,2.3,1.7,2.3c1.3,0,1.7-1.1,1.7-2.3C132.1,119.2,131.8,118,130.4,118z M130.4,121.9
			c-0.7,0-0.8-0.8-0.8-1.6c0-0.8,0.1-1.6,0.8-1.6c0.7,0,0.8,0.8,0.8,1.6C131.2,121.1,131.1,121.9,130.4,121.9z M134.9,120.9
			c0.5-0.5,0.8-1,0.8-1.5c0-0.8-0.6-1.4-1.6-1.4c-1,0-1.5,0.6-1.6,1.4h0.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.6
			c0,0.3-0.2,0.6-0.6,1l-1.6,1.5v0.7h3.1v-0.8h-1.9L134.9,120.9z M138,118c-1.3,0-1.7,1.1-1.7,2.3c0,1.2,0.3,2.3,1.7,2.3
			c1.3,0,1.7-1.1,1.7-2.3C139.7,119.2,139.3,118,138,118z M138,121.9c-0.7,0-0.8-0.8-0.8-1.6c0-0.8,0.1-1.6,0.8-1.6
			c0.7,0,0.8,0.8,0.8,1.6C138.8,121.1,138.7,121.9,138,121.9z"
            />
          </g>
        ) : (
          <g id="tulevaisuus_12_">
            <path
              id="plate_38_"
              className="st5"
              d="M178.7,114.9h-35.2c-3.1,0-5.7,2.5-5.7,5.7c0,3.1,2.5,5.7,5.7,5.7h35.2c3.1,0,5.7-2.5,5.7-5.7
			C184.4,117.4,181.9,114.9,178.7,114.9z"
            />
            <path
              id="tulevaisuus_13_"
              className="st17"
              d="M146.5,117.9h-4.3v0.8h1.7v4.4h0.9v-4.4h1.7V117.9z M148.8,121.6c0,0.5-0.4,0.9-0.9,0.9
			c-0.5,0-0.7-0.3-0.7-0.7v-2.3h-0.8v2.4c0,0.7,0.5,1.3,1.3,1.3c0.5,0,0.8-0.2,1.1-0.5h0v0.4h0.8v-3.7h-0.8V121.6z M151.4,122v-4.1
			h-0.8v4.2c0,0.6,0.3,1,0.9,1h0.5v-0.7h-0.2C151.5,122.4,151.4,122.3,151.4,122z M154,119.4c-1.1,0-1.7,0.8-1.7,1.9
			c0,1.1,0.7,1.9,1.8,1.9c0.8,0,1.4-0.4,1.6-1.2h-0.8c-0.1,0.3-0.4,0.5-0.8,0.5c-0.6,0-0.9-0.4-1-1h2.6c0-0.1,0-0.3,0-0.4
			C155.7,120.1,155.1,119.4,154,119.4z M153.1,120.9c0.1-0.5,0.4-0.9,0.9-0.9c0.6,0,0.8,0.3,0.9,0.9H153.1z M157.7,122L157.7,122
			l-0.9-2.6h-0.9l1.4,3.7h0.7l1.4-3.7h-0.9L157.7,122z M161.3,119.4c-0.9,0-1.5,0.4-1.5,1.2h0.8c0-0.3,0.2-0.5,0.7-0.5
			c0.5,0,0.7,0.2,0.7,0.5c0,0.3-0.1,0.3-0.7,0.4c-0.5,0.1-0.9,0.2-1.2,0.4c-0.2,0.2-0.4,0.4-0.4,0.8c0,0.6,0.4,1.1,1.2,1.1
			c0.5,0,0.8-0.2,1.1-0.5h0v0.4h0.8v-2.5C162.8,119.9,162.3,119.4,161.3,119.4z M162,121.8c0,0.4-0.3,0.8-0.9,0.8
			c-0.4,0-0.6-0.2-0.6-0.5c0-0.3,0.3-0.4,0.8-0.5c0.3-0.1,0.5-0.1,0.6-0.2V121.8z M163.9,118.7h0.9v-0.8h-0.9V118.7z M163.3,120.2
			h0.6v3h0.8v-3.7h-1.4V120.2z M167.2,120.9c-0.6-0.1-0.9-0.2-0.9-0.5c0-0.2,0.2-0.4,0.6-0.4c0.4,0,0.6,0.2,0.6,0.5h0.8
			c0-0.7-0.5-1.1-1.4-1.1c-0.9,0-1.4,0.5-1.4,1.1c0,0.7,0.6,0.9,1.2,1.1c0.7,0.2,0.9,0.3,0.9,0.5c0,0.3-0.3,0.5-0.7,0.5
			c-0.5,0-0.8-0.2-0.8-0.6h-0.8c0,0.7,0.6,1.2,1.5,1.2c0.9,0,1.5-0.5,1.5-1.2C168.4,121.3,167.9,121.1,167.2,120.9z M171.5,121.6
			c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.7-0.3-0.7-0.7v-2.3h-0.8v2.4c0,0.7,0.5,1.3,1.3,1.3c0.5,0,0.8-0.2,1.1-0.5h0v0.4h0.8v-3.7h-0.8
			V121.6z M175.6,121.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.7-0.3-0.7-0.7v-2.3h-0.8v2.4c0,0.7,0.5,1.3,1.3,1.3c0.5,0,0.8-0.2,1.1-0.5h0
			v0.4h0.8v-3.7h-0.8V121.6z M178.9,120.9c-0.6-0.1-0.9-0.2-0.9-0.5c0-0.2,0.2-0.4,0.6-0.4c0.4,0,0.6,0.2,0.6,0.5h0.8
			c0-0.7-0.5-1.1-1.4-1.1c-0.9,0-1.4,0.5-1.4,1.1c0,0.7,0.6,0.9,1.2,1.1c0.7,0.2,0.9,0.3,0.9,0.5c0,0.3-0.3,0.5-0.7,0.5
			c-0.5,0-0.8-0.2-0.8-0.6h-0.8c0,0.7,0.6,1.2,1.5,1.2c0.9,0,1.5-0.5,1.5-1.2C180.1,121.3,179.6,121.1,178.9,120.9z"
            />
          </g>
        )}
      </g> */}
      <g id="elevator_2_">
        <path
          id="plate_5_"
          className="st5"
          d="M224.2,13.5c-8.4,0-15.1,6.8-15.1,15.2v56.2c0,8.4,6.8,15.2,15.1,15.2c8.4,0,15.2-6.8,15.2-15.2
		V28.7C239.4,20.3,232.6,13.5,224.2,13.5z"
        />
        <g id="_x38__1_">
          <path
            className="st0"
            d="M224.2,45.3c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S230.6,45.3,224.2,45.3z"
          />
          <g>
            <path
              className="st5"
              d="M221.1,58.8c0-0.9,0.5-1.7,1.3-2v0c-0.7-0.4-1.2-1.1-1.2-1.9c0-1.3,1.1-2.4,3.1-2.4c2,0,3.1,1,3.1,2.4
				c0,0.8-0.4,1.5-1.2,1.9v0c0.9,0.4,1.3,1.1,1.3,2c0,1.4-1.2,2.5-3.2,2.5C222.2,61.2,221.1,60.2,221.1,58.8z M225.9,58.6
				c0-0.7-0.6-1.3-1.6-1.3c-1,0-1.6,0.5-1.6,1.3s0.6,1.3,1.6,1.3C225.3,59.8,225.9,59.3,225.9,58.6z M225.8,54.9
				c0-0.6-0.5-1.1-1.4-1.1c-0.9,0-1.4,0.5-1.4,1.1c0,0.7,0.5,1.2,1.4,1.2C225.2,56.1,225.8,55.6,225.8,54.9z"
            />
          </g>
        </g>
        <g id="down_2_" onClick={() => changeFloor('down')}>
          <path
            className="st11"
            d="M224.2,92c-3.8,0-6.9-3-6.9-6.9s3-6.9,6.9-6.9c3.7,0,6.9,3,6.9,6.9S227.9,92,224.2,92z"
          />
          <path
            className="st11"
            d="M224.2,78.2c-3.8,0-6.9,3-6.9,6.9s3,6.9,6.9,6.9c3.7,0,6.9-3,6.9-6.9S227.9,78.2,224.2,78.2z"
          />
          <path
            className="st5"
            d="M228.7,83.8l0.4,0.5l-4.5,3c-0.1,0.1-0.4,0.1-0.5,0l-4.5-3l0.4-0.5l4.2,2.8c0.1,0.1,0.3,0.1,0.4,0L228.7,83.8
			z"
          />
        </g>
        <g id="up_2_" onClick={() => changeFloor('up')}>
          <path
            className="st11"
            d="M224.2,21.6c-3.8,0-6.9,3-6.9,6.9s3,6.9,6.9,6.9c3.7,0,6.9-3,6.9-6.9S227.9,21.6,224.2,21.6z"
          />
          <path
            className="st11"
            d="M224.2,35.4c-3.8,0-6.9-3-6.9-6.9s3-6.9,6.9-6.9c3.7,0,6.9,3,6.9,6.9S227.9,35.4,224.2,35.4z"
          />
          <path
            className="st5"
            d="M228.7,29.8l0.4-0.5l-4.5-3c-0.1-0.1-0.4-0.1-0.5,0l-4.5,3l0.4,0.5l4.2-2.8c0.1-0.1,0.3-0.1,0.4,0L228.7,29.8
			z"
          />
        </g>
      </g>
      <g id="view_3_">
        <g id="B60_1_">
          <linearGradient
            id="B60cone_1_"
            gradientUnits="userSpaceOnUse"
            x1="279.2493"
            y1="315.8223"
            x2="279.2493"
            y2="270.9123"
            gradientTransform="matrix(0 1 1 0 -149.7621 -185.0643)"
          >
            <stop offset="1.020000e-02" style={{ stopColor: '#FFFFFF' }} />
            <stop offset="1" style={{ stopColor: '#FFFFFF', stopOpacity: 0 }} />
          </linearGradient>
          {apartmentNumber === 60 ? (
            <>
              <path
                id="B60cone"
                className="st12"
                d="M166,97.6c-0.4-0.9-0.6-1.9-0.6-2.9c0-1,0.2-2,0.6-2.9l-44.9-19.5v43.8L166,97.6z"
                transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
              />
              <circle
                id="B60_2_"
                className="st13"
                cx={`${pivots[apartmentNumber][0]}`}
                cy={`${pivots[apartmentNumber][1]}`}
                r="1.7"
              />
            </>
          ) : null}
        </g>
        <g id="B61_2_">
          <linearGradient
            id="B61cone_1_"
            gradientUnits="userSpaceOnUse"
            x1="279.8543"
            y1="272.7473"
            x2="279.8543"
            y2="227.8373"
            gradientTransform="matrix(0 1 1 0 -149.7621 -185.0643)"
          >
            <stop offset="1.020000e-02" style={{ stopColor: '#FFFFFF' }} />
            <stop offset="1" style={{ stopColor: '#FFFFFF', stopOpacity: 0 }} />
          </linearGradient>
          {apartmentNumber === 61 ? (
            <>
              <path
                id="B61cone"
                className="st14"
                d="M123,98.2c-0.4-0.9-0.6-1.9-0.6-2.9c0-1,0.2-2,0.6-2.9L78.1,72.9v43.8L123,98.2z"
                transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
              />
              <circle
                id="_x36_1"
                className="st13"
                cx={`${pivots[apartmentNumber][0]}`}
                cy={`${pivots[apartmentNumber][1]}`}
                r="1.7"
              />
            </>
          ) : null}
        </g>
        <g id="B62_2_">
          <linearGradient
            id="B62cone_1_"
            gradientUnits="userSpaceOnUse"
            x1="298.1243"
            y1="236.5097"
            x2="298.1243"
            y2="191.5997"
            gradientTransform="matrix(0 1 1 0 -149.7621 -185.0643)"
          >
            <stop offset="1.020000e-02" style={{ stopColor: '#FFFFFF' }} />
            <stop offset="1" style={{ stopColor: '#FFFFFF', stopOpacity: 0 }} />
          </linearGradient>
          {apartmentNumber === 62 ? (
            <>
              <path
                id="B62cone"
                className="st15"
                d="M86.7,116.4c-0.4-0.9-0.6-1.9-0.6-2.9c0-1,0.2-2,0.6-2.9L41.8,91.2V135L86.7,116.4z"
                transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
              />
              <circle
                id="B62_4_"
                className="st13"
                cx={`${pivots[apartmentNumber][0]}`}
                cy={`${pivots[apartmentNumber][1]}`}
                r="1.7"
              />
            </>
          ) : null}
        </g>
        <g id="B63_2_">
          <linearGradient
            id="B63cone_1_"
            gradientUnits="userSpaceOnUse"
            x1="201.6693"
            y1="162.4899"
            x2="201.6693"
            y2="117.5799"
            gradientTransform="matrix(0 1 1 0 -149.7621 -185.0643)"
          >
            <stop offset="1.020000e-02" style={{ stopColor: '#FFFFFF' }} />
            <stop offset="1" style={{ stopColor: '#FFFFFF', stopOpacity: 0 }} />
          </linearGradient>
          {apartmentNumber === 63 ? (
            <>
              <path
                id="B63cone"
                className="st16"
                d="M12.7,20c-0.4-0.9-0.6-1.9-0.6-2.9c0-1,0.2-2,0.6-2.9L-32.2-5.3v43.8L12.7,20z"
                transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
              />
              <circle
                id="B63_4_"
                className="st13"
                cx={`${pivots[apartmentNumber][0]}`}
                cy={`${pivots[apartmentNumber][1]}`}
                r="1.7"
              />
            </>
          ) : null}
        </g>
      </g>
      <g id="copyright_2_"></g>
      <g id="title_2_"></g>
    </SVG>
  )
}
const pivots = {
  60: [170.6, 94.8],
  61: [127.6, 95.4],
  62: [91.3, 113.7],
  63: [17.3, 17.2],
}
